import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRecords = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1888_90121)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M11.2998 1.12109H3.6998C3.19589 1.12109 2.71262 1.32127 2.3563 1.67759C1.99998 2.03391 1.7998 2.51718 1.7998 3.02109V18.2211C1.7998 18.725 1.99998 19.2083 2.3563 19.5646C2.71262 19.9209 3.19589 20.1211 3.6998 20.1211H15.0998C15.6037 20.1211 16.087 19.9209 16.4433 19.5646C16.7996 19.2083 16.9998 18.725 16.9998 18.2211V6.82109L11.2998 1.12109Z",
					fill: "#DBE4E8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M2.00275 1.32404C2.45284 0.87395 3.06329 0.621094 3.6998 0.621094H11.2998C11.4324 0.621094 11.5596 0.673772 11.6534 0.76754L17.3534 6.46754C17.4471 6.56131 17.4998 6.68849 17.4998 6.82109V18.2211C17.4998 18.8576 17.2469 19.4681 16.7969 19.9181C16.3468 20.3682 15.7363 20.6211 15.0998 20.6211H3.6998C3.06328 20.6211 2.45284 20.3682 2.00275 19.9181C1.55266 19.4681 1.2998 18.8576 1.2998 18.2211V3.02109C1.2998 2.38457 1.55266 1.77412 2.00275 1.32404ZM3.6998 1.62109C3.3285 1.62109 2.97241 1.76859 2.70986 2.03114C2.4473 2.29369 2.2998 2.64979 2.2998 3.02109V18.2211C2.2998 18.5924 2.4473 18.9485 2.70986 19.211C2.97241 19.4736 3.3285 19.6211 3.6998 19.6211H15.0998C15.4711 19.6211 15.8272 19.4736 16.0898 19.211C16.3523 18.9485 16.4998 18.5924 16.4998 18.2211V7.0282L11.0927 1.62109H3.6998Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.2998 1.62109C10.5759 1.62109 10.7998 1.84495 10.7998 2.12109V7.32109H15.9998C16.2759 7.32109 16.4998 7.54495 16.4998 7.82109C16.4998 8.09724 16.2759 8.32109 15.9998 8.32109H10.2998C10.0237 8.32109 9.7998 8.09724 9.7998 7.82109V2.12109C9.7998 1.84495 10.0237 1.62109 10.2998 1.62109Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M5.09961 11.571C5.09961 11.2949 5.32347 11.071 5.59961 11.071H13.1996C13.4758 11.071 13.6996 11.2949 13.6996 11.571C13.6996 11.8472 13.4758 12.071 13.1996 12.071H5.59961C5.32347 12.071 5.09961 11.8472 5.09961 11.571Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M5.09961 15.3711C5.09961 15.095 5.32347 14.8711 5.59961 14.8711H13.1996C13.4758 14.8711 13.6996 15.095 13.6996 15.3711C13.6996 15.6472 13.4758 15.8711 13.1996 15.8711H5.59961C5.32347 15.8711 5.09961 15.6472 5.09961 15.3711Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M5.09961 7.771C5.09961 7.49485 5.32347 7.271 5.59961 7.271H7.49961C7.77575 7.271 7.99961 7.49485 7.99961 7.771C7.99961 8.04714 7.77575 8.271 7.49961 8.271H5.59961C5.32347 8.271 5.09961 8.04714 5.09961 7.771Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.2998 4.12109H8.6998C8.19589 4.12109 7.71262 4.32127 7.3563 4.67759C6.99998 5.03391 6.7998 5.51718 6.7998 6.02109V21.2211C6.7998 21.725 6.99998 22.2083 7.3563 22.5646C7.71262 22.9209 8.19589 23.1211 8.6998 23.1211H20.0998C20.6037 23.1211 21.087 22.9209 21.4433 22.5646C21.7996 22.2083 21.9998 21.725 21.9998 21.2211V9.82109L16.2998 4.12109Z",
					fill: "#DBE4E8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.00275 4.32404C7.45284 3.87395 8.06329 3.62109 8.6998 3.62109H16.2998C16.4324 3.62109 16.5596 3.67377 16.6534 3.76754L22.3534 9.46754C22.4471 9.56131 22.4998 9.68849 22.4998 9.82109V21.2211C22.4998 21.8576 22.2469 22.4681 21.7969 22.9181C21.3468 23.3682 20.7363 23.6211 20.0998 23.6211H8.6998C8.06328 23.6211 7.45284 23.3682 7.00275 22.9181C6.55266 22.4681 6.2998 21.8576 6.2998 21.2211V6.02109C6.2998 5.38457 6.55266 4.77412 7.00275 4.32404ZM8.6998 4.62109C8.3285 4.62109 7.97241 4.76859 7.70986 5.03114C7.4473 5.29369 7.2998 5.64979 7.2998 6.02109V21.2211C7.2998 21.5924 7.4473 21.9485 7.70986 22.211C7.97241 22.4736 8.3285 22.6211 8.6998 22.6211H20.0998C20.4711 22.6211 20.8272 22.4736 21.0898 22.211C21.3523 21.9485 21.4998 21.5924 21.4998 21.2211V10.0282L16.0927 4.62109H8.6998Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.2998 3.62109C16.5759 3.62109 16.7998 3.84495 16.7998 4.12109V9.32109H21.9998C22.2759 9.32109 22.4998 9.54495 22.4998 9.82109C22.4998 10.0972 22.2759 10.3211 21.9998 10.3211H16.2998C16.0237 10.3211 15.7998 10.0972 15.7998 9.82109V4.12109C15.7998 3.84495 16.0237 3.62109 16.2998 3.62109Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.0996 14.571C10.0996 14.2949 10.3235 14.071 10.5996 14.071H18.1996C18.4758 14.071 18.6996 14.2949 18.6996 14.571C18.6996 14.8472 18.4758 15.071 18.1996 15.071H10.5996C10.3235 15.071 10.0996 14.8472 10.0996 14.571Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.0996 18.3711C10.0996 18.095 10.3235 17.8711 10.5996 17.8711H18.1996C18.4758 17.8711 18.6996 18.095 18.6996 18.3711C18.6996 18.6472 18.4758 18.8711 18.1996 18.8711H10.5996C10.3235 18.8711 10.0996 18.6472 10.0996 18.3711Z",
					fill: "#293235"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.0996 10.771C10.0996 10.4949 10.3235 10.271 10.5996 10.271H12.4996C12.7758 10.271 12.9996 10.4949 12.9996 10.771C12.9996 11.0471 12.7758 11.271 12.4996 11.271H10.5996C10.3235 11.271 10.0996 11.0471 10.0996 10.771Z",
					fill: "#293235"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1888_90121",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(0 0.121094)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgRecords);
export { ForwardRef as ReactComponent };
